import {Component, Inject, Input, OnInit, EventEmitter, Output, ViewChild, HostListener} from 'ng-metadata/core';
import {ActionListService} from './actionList.service';
import {PrimolyticsService} from '../../analytics/primolytics.service';
import {MediaQueries} from '../../infra/mediaQueries.service';
import {PrimoResponse} from '../../infra/dataStructures/PrimoResponses/doc.interfcae';
import {ConfigurationUtil} from "../../nddUtils/configurationUtil.service";
import {ScrollService} from "../scroller/scroll.service";
import {isBrowserSafari} from '../../infra/browserSniffer';
import {LegantoService} from './legantoAction/leganto.service';
import {STATE_NAMES} from '../../primoExplore/primoExploreStates.module';
import {ChangeLangService} from "../../infra/lang/changeLang.service";
import { BriefResultService } from '../briefResult/briefResult.service';
import {QrCodeService} from "../topbar/qrCode/qrCode.service";
import { UserSessionManagerService } from '../../security/userSessionManager.service';
import {AuthoritySearchService} from "../authority/authoritySearch.service";
import {getEnableEmailClient} from "../../appConfig/appConfigForward";
import {EmailClientService} from "./sendEmailAction/emailClient.service";

@Component({
    'selector': 'prm-action-list',
    templateUrl: 'components/search/actions/action-list.html'
})


export class PrmActionList implements OnInit {
    showPermalinkAction: boolean;
    @Input() item: PrimoResponse.IDoc;
    @Input() public selectedIds: any;
    @Input() selectedIds: any;
    @Input() displaymode: any;
    @Input() selectedAction: string;
    @Input() displayAll: boolean;
    @Input() isFullView: boolean;
    @Input() private isOverlayFullView:boolean;
    @Input() displayCloseIcon: any;
    private activeAction: string;
    @ViewChild('md-nav-bar') firstItem: ng.IAugmentedJQuery;
    @Output() private closeModal = new EventEmitter<void>();
    @Output() private tabPressed = new EventEmitter<void>();


    private expanded: boolean = false;
    public actionIconNamesMap = {
        'E-mail': 'email', 'Citation': 'citations', 'Permalink': 'permalink', 'Print': 'print',
        'EndNote': 'endnote', 'EasyBib': 'easybib', 'RefWorks': 'refworks', 'RISPushTo': 'ris', 'BibTeXPushTo': 'ris',
        'Mendeley' : 'mendeley', 'Leganto': 'ris', 'Excel': 'excel', 'QR': 'qr' ,'Share' : 'share'
    };
    public expandedAction = '';
    public expandableActions = {
        'E-mail': true,
        'Citation': true,
        'Permalink': true,
        'Print': false,
        'EndNote': false,
        'EasyBib': false,
        'RefWorks': false,
        'RISPushTo': true,
        'BibTeXPushTo': true,
        'Leganto': true,
        'Mendeley': false,
        'Excel':true,
        'QR':true,
        'Share': true
    };
    public actionLabelNamesMap;
    private getTabItemSize = 'never';
    private showAction = {
        'Permalink': () => {
            return this.item.context !== 'MetaLib';
        }
    }
    private ACTION_ITEM_ID_PREFIX = 'actionListItem';
    private KEY_CODE = {
        COMMA: 188,
        SEMICOLON: 186,
        ENTER: 13,
        ESCAPE: 27,
        SPACE: 32,
        PAGE_UP: 33,
        PAGE_DOWN: 34,
        END: 35,
        HOME: 36,
        LEFT_ARROW: 37,
        UP_ARROW: 38,
        RIGHT_ARROW: 39,
        DOWN_ARROW: 40,
        TAB: 9,
        BACKSPACE: 8,
        DELETE: 46
    };


    private promiseActionNames;  // Action names that will be processes synchronically
    private actionInnerService;
    private isAuthoritySearch: boolean = false;
    actionButtonsElements: [Element];

	constructor(private actionListService: ActionListService,
				private briefResultService: BriefResultService,
                @Inject('actionIcons') private  actionIcons: Object,
                @Inject('$scope') private $scope: ng.IScope,
                private primolyticsService: PrimolyticsService,
                @Inject('$state') private $state: ng.ui.IStateService,
                @Inject('$timeout') private $timeout: ng.ITimeoutService,
                private mediaQueries: MediaQueries,
                @Inject('$element') private $element: ng.IAugmentedJQuery,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                @Inject('featuredActionsIcons') private actionsIcons,
                private configurationUtil: ConfigurationUtil,
                private scrollService: ScrollService,
                private changeLangService: ChangeLangService,
                private legantoService: LegantoService,
                private userSessionManagerService: UserSessionManagerService,
                private authoritySearchService: AuthoritySearchService,
                private qrCodeService: QrCodeService,
                private emailService: EmailClientService) {

        this.isAuthoritySearch = this.authoritySearchService.isAuthorityState();
    }

    getActionTranslate(actionName) {
        let label = 'fulldisplay.command.' + this.actionLabelNamesMap[actionName];
        return this.$translate.instant(label);
    }

    ngOnInit() {
        this.$timeout(() => {
            this.actionButtonsElements = this.$element[0].querySelectorAll('.actions-names button');
            this.watchAriaExpandedValue();
            this.fixActionListRoles();
        }, 400, false);

        this.$timeout(() => {
            this.unfocusActionButtons2('md-nav-bar button');
            this.unfocusActionButtons2('md-nav-bar nav');
        }, 400, false);

        this.actionLabelNamesMap = {
            'E-mail': 'email',
            'Citation': 'citation',
            'Permalink': ((this.isServicesPage()) ? 'link' : 'permalink'),
            'Print': 'print',
            'EndNote': 'pushto.option.EndNote',
            'EasyBib': 'pushto.option.EasyBib',
            'RefWorks': 'pushto.option.RefWorks',
            'RISPushTo': 'pushto.option.RISPushTo',
            'BibTeXPushTo': 'pushto.option.BibTeXPushTo',
            'Mendeley' : 'pushto.option.Mendeley',
            'Leganto': 'pushto.option.Leganto',
            'Excel': 'pushto.option.Excel',
            'QR': 'pushto.option.qr',
            'Share':'pushto.option.share'
        };
        this.activeAction = (this.selectedAction && this.selectedAction !== 'none') ? this.selectedAction : this.requiredActionsList;
        // In case there is a need to use action that should recieve info from the server side
        // before opening the box then we should add this action to 'promiseActionNames'
        // e.g. In Leganto we need to fetch lists before opening the box (we won't open the box
        // in case the list is empty). In such case we'll add "'Leganto' : this.legantoService".
        // NOTE: following a design change in Leganto action, the box will be opened in all cases
        //       so we removed it from 'promiseActionNames' parameter.
        this.promiseActionNames = {};
        this.actionInnerServices = {'Leganto': this.legantoService};

        this.actionListHeader();
    }

    ngAfterViewInit() {
        if (!this.isFullView) {
            this.$timeout(() => {
                this.$timeout(() => {
                    this.firstItem[0].querySelectorAll('li button')[0].focus();
                });
            }, 0, false);
        }
    }

    /* This function fixes accesibility issue with the roles of action list by adding ids to the buttons (roles tab) 
    and adding those ids to the ul element (role tablist) aria-owns attribute. */
    private fixActionListRoles() {
        let ariaOwnsVal = '';
        const idPostfix = this.isFullView ? 'ButtonFullView' : 'Button';
        for (let button of this.actionButtonsElements) {
            const actionName = button.parentElement.id;
            button.setAttribute('id', actionName + idPostfix);
            ariaOwnsVal += actionName + idPostfix + ' ';
        }
        const actionListElm: Element = this.$element[0].querySelector('md-nav-bar ul');
        if(actionListElm){
            actionListElm.setAttribute('aria-owns', ariaOwnsVal);
        }
        let elements = document.querySelectorAll('.actions-names');
        if(elements) {
            elements.forEach(element => {
                element.setAttribute("role", "tab");
            });
        }
    }

    //this function remove tabindex=-1 from all li buttons so that they focused with Tab key when action list is open.
    //also, this function set role="list" attribute to the all actions list.
    private unfocusActionButtons2(str){
        let actionButtons: [Element]= this.$element[0].querySelectorAll(str);
        if(this.$element){
            for(let li of actionButtons){
                li.removeAttribute('tabindex');
            }
        }
    }


    private performAction(actionName) {
        // store the service of the action (e.g. 'Leganto') so we'll be able to access
        // variables from the html (e.g for the spinner on/off).
        if (this.actionInnerServices[actionName]) {
            this.actionInnerService = this.actionInnerServices[actionName];
        }

        if(actionName === 'Leganto'){                           //Leganto action should fire beacon calls only for signed-in users
            if (!this.userSessionManagerService.isGuest()){
                this.primolyticsService.doBeaconReport({
                    'p': 'sendTo',
                    'op': actionName
                }, this.item, this.primolyticsService.getTimestamp());

                if (this.isSearchState() && this.briefResultService.openedFromTopActionBar) {
                    this.primolyticsService.doBeaconReport({
                        'p': 'brief',
                        'op': 'sendBulkTo' + actionName
                    }, this.item, this.primolyticsService.getTimestamp());
                }
            }
        }
        else if(actionName !== 'Citation'){
            this.primolyticsService.doBeaconReport({
                'p': 'sendTo',
                'op': actionName
            }, this.item, this.primolyticsService.getTimestamp());
            
            if (this.isSearchState() && this.briefResultService.openedFromTopActionBar) {
				this.primolyticsService.doBeaconReport({
					'p': 'brief',
					'op': 'sendBulkTo' + actionName
				}, this.item, this.primolyticsService.getTimestamp());
			}
        }

        if (this.promiseActionNames[actionName] && this.actionListService.onToggle[actionName]) {
            this.performPromiseAction(actionName);
        }
        else {
            if (this.actionListService.onToggle[actionName]) { //action which open new window should have a callback set on the onToggle object to overcome popup blocker. Other actions can be invoked via the action directive constructor
                this.actionListService.onToggle[actionName](this.item, this.selectedIds);
            }
            document.querySelector("#" + actionName).querySelector('button').focus();
            this.userSelectedAction(actionName);

        }

        //this function set tabindex="0" for selected action and set all the rest tabindex="-1"
        let actionButtons: [Element] = document.querySelectorAll("md-nav-bar li");
        for (let li of actionButtons) {
            if (li.id === actionName) {
                li.getElementsByTagName("button")[0].setAttribute("tabindex", "0");
            }
            else {
                li.getElementsByTagName("button")[0].setAttribute("tabindex", "-1");
            }
        }

        this.expandedAction = this.expandableActions[actionName] ? actionName : '';

    }

    private userSelectedAction(actionName: string): void {
        if(actionName !== 'E-mail' || !getEnableEmailClient())
            this.selectedAction = actionName;
    }

    //this function set aria-expanded attribute on actions list buttons
    private watchAriaExpandedValue() {
        for (let actionButtonElement of this.actionButtonsElements) {
            const parentElement = actionButtonElement.parentElement;
            const actionName = parentElement.id;

            if (this.expandableActions[actionName]) {

                actionButtonElement.setAttribute('aria-expanded', this.expandedAction == actionName);

                this.$scope.$watch(()=> this.expandedAction, ()=> {
                    actionButtonElement.setAttribute('aria-expanded', this.expandedAction == actionName);
                });
            }
        }
    }

    private actionListHeader() {
        let pageElement = document.querySelector('prm-action-list nav');
        if(pageElement){
            pageElement.setAttribute('aria-label', this.$translate.instant('nui.aria.actions.options'));
        }    
    }

    private translateAction(actionName) {
        let recordTitle = this.getRecordTitle(actionName);
        if (recordTitle) {
            return `${this.getActionTranslate(actionName)} ${this.$translate.instant('nui.aria.action.nameTitle')} ${this.getRecordTitle(actionName)}`;
        }

        return `${this.getActionTranslate(actionName)} ${this.$translate.instant('nui.aria.action.nameTitle')}`;
    }

    // run the processes syncronically
    private performPromiseAction(actionName) {
        if (this.promiseActionNames[actionName].isAllowedUser()) {
            let pushtoPromise = this.actionListService.onToggle[actionName](this.item, this.selectedIds);

            pushtoPromise.then((response)=> {
                this.promiseActionNames[actionName].successfullFetchLists(response);
                document.querySelector("#" + actionName).querySelector('button').focus();

                // Action box will be opened only in case 'setSelectedAction' not exists or it'snot set to 'false'
                if (response.setSelectedAction !== false) {
                    this.selectedAction = actionName;
                }
            }, (response)=>this.promiseActionNames[actionName].failedFetchLists(response));
        }
    }

    get isLeftScrollDisabled(): boolean {
        return this.scrollService.isShowLeftArrow(document.querySelector("#scrollActionList"));
        // if(document.querySelector(".md-nav-bar").scrollLeft === 0){
        //     return false;
        // }
        // return true;
    }

    get isRightScrollDisabled(): boolean {
        return this.scrollService.isShowRightArrow(document.querySelector("#scrollActionList"));
        // // document.querySelector(".md-nav-bar").
        // let currentWidth = document.querySelector(".md-nav-bar").scrollLeft;
        // document.querySelector(".md-nav-bar").scrollLeft +=3;
        // if(currentWidth ==document.querySelector(".md-nav-bar").scrollLeft ) {
        //     return false;
        // }
        // document.querySelector(".md-nav-bar").scrollLeft -=3;
        // return true;
    }

    public scrollLeftMouseDown(): void {
        this.scrollService.onLeftArrowClick(document.querySelector("#scrollActionList"));
        //document.querySelector(".md-nav-bar").scrollLeft -= 10;
    }

    public scrollRightMouseDown() {
        this.scrollService.onRightArrowClick(document.querySelector("#scrollActionList"));
        //document.querySelector(".md-nav-bar").scrollLeft += 10;
    }

    private isServicesPage() {
        if (this.$state.current.name === 'servicesPage') {
            return true;
        }
        return false;
	}
	
	isSearchState() {
		return this.$state.current.name === STATE_NAMES.SEARCH;
	}

    doAlert(exportType, evt) {
        alert('TO DO: export to ' + exportType + '');
        evt.stopPropagation();
    }

    closeAllTabs() {
        this.selectedAction = '';
    }

    get requiredActionsList() {

        let actionList = this.actionListService.requiredActionsList;
        if (!this.displayAll) {
            actionList = actionList.filter((actionName)=>!(actionName === 'Permalink' || actionName === 'Citation'  || actionName === 'QR' || actionName === 'Share'));
            actionList = getEnableEmailClient() ? actionList.filter(actionList => actionList !== 'E-mail') : actionList;
        } else if (!this.shouldDisplayAll(this.item)) {
            actionList = actionList.filter((actionName)=>!(actionName === 'Permalink'));
        }

        if(this.isAuthoritySearch){
            actionList = actionList.filter((actionName)=>(actionName === 'Permalink' || actionName === 'Print' || actionName === 'E-mail'));
        }
        return actionList;
    }

    public showMe(actionName) {
        if (actionName == '') {
            return false;
        }

        if (!this.showAction[actionName]) {
            return true;
        }

        return this.showAction[actionName]();
    }

    private showAccessibleCloseButton(){
        if (!this.expandedAction && this.isFullView) {
            return false;
        }
        return true;
    }

    private shouldDisplayAll(item) {

        if (Array.isArray(item)) {
            // The only way array could get here is from the multiple selection of favorite items
            // In this case we don't need this test
            // This should not happen but we leave it just in case
            return true;
        }
        if (this.configurationUtil.isSuprima()) {
            return true;
        }

        if (item && (item.context === 'Ebsco' || (item.pnx && item.pnx.control.sourcesystem && item.pnx.control.sourcesystem[0] === 'ebsco'))) {
            return false;
        } else {
            return true;
        }
    }

    private closeModalActions(evt) {
        //Close button for open expandedAction - close only the prm-action-container
        if (this.expandedAction) {
            let actionBtnSelector = "#" + this.expandedAction + " button";
            const button = document.querySelector(actionBtnSelector);

            //Reset actions list values after click on close
            button.focus();
            this.expandedAction = '';
            this.selectedAction = 'none';

            const actionButtons: [Element] = this.firstItem[0].querySelectorAll('li');

            for (let li of actionButtons) {
                li.getElementsByTagName("button")[0].setAttribute('tabindex', '0');
            }

            return;
        }

        //Close button for open modal actions list - close the prm-action-list
            this.closeModal.emit(evt);
    }

    // This function called only from 'close' button !!!
    private keydownSupport(e) {
        let keyCodes = this.KEY_CODE;
        
        if (e.keyCode === keyCodes.TAB) {
            e.preventDefault();
            if(this.selectedAction === 'none'){ // In case we are in outer single 'close' button
                return this.firstItem[0].querySelectorAll('li button')[0].focus();
            }else{ // In case we are in inner 'close' button of Internal action or get to 'close' after external (new tab) action
                let actionBtnSelector = "#" + this.activeAction + " button";
                return document.querySelector(actionBtnSelector).focus()
            }
        }
    }

    private getRecordTitle(actionName) {

        if (!this.item) {
            return
        }

        let recordTitle;
        if (Array.isArray(this.item) && this.item.length > 1) {
            recordTitle = this.$translate.instant('nui.aria.selectedItems');
        }
        else if (Array.isArray(this.item) && this.item.length === 1) {
            recordTitle = this.item[0].pnx.display['title'][0];
        }
        else {
            recordTitle = this.item.pnx.display['title'][0];
        }
        //Indication if action list open in a new window or expandedAction
        if (actionName && this.actionListService.onToggle[actionName]) { //action which open new window should have a callback set on the onToggle object to overcome popup blocker. Other actions can be invoked via the action directive constructor
            recordTitle = recordTitle + this.$translate.instant('nui.aria.newWindow');
        }
        return recordTitle;
    }

    public isSafariBrowse() {
        return isBrowserSafari();
    }

    public getDirection(){
        return this.changeLangService.direction;
    }

    public isfullViewOrOverlay() {
        return (this.isFullView || this.isOverlayFullView);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/actions/actionList.directive.ts